import { defineMessages } from "react-intl";
import { InvitationType } from "./api";

export const INVITATION_TYPE_MESSAGES = defineMessages<InvitationType>({
    BASIC: { id: "InvitationType.BASIC", defaultMessage: "Participant" },
    HOST: { id: "InvitationType.HOST", defaultMessage: "Host" },
});
